/*
 * DRIVLY-UI React Components
 * @license MIT
 */
function e(){return{before({doc:e,d:o}){o.style(e.documentElement,"overflow","hidden")}}}export{e as preventScroll};
//# sourceMappingURL=prevent-scroll.js.map
